module.exports = __webpack_public_path__ + "img/1f4b00c.png";